/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Work_Order_Import_Status_Importing_TrackInputs */

const en_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing track ${i?.index}`)
};

const fr_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation de la piste ${i?.index}`)
};

const de_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importiere Track ${i?.index}`)
};

const it_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione della traccia ${i?.index}`)
};

const ru_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт трека ${i?.index}`)
};

const es_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando pista ${i?.index}`)
};

const zh_cn2_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导入轨道 ${i?.index}`)
};

const ja_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.index} をインポートしています`)
};

const hi_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.index} आयात किया जा रहा है`)
};

const pt_pt2_work_order_import_status_importing_track = /** @type {(inputs: Work_Order_Import_Status_Importing_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando faixa ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Importing track {index}" |
*
* @param {Work_Order_Import_Status_Importing_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_importing_track = /** @type {((inputs: Work_Order_Import_Status_Importing_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Importing_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_importing_track(inputs)
	if (locale === "de") return de_work_order_import_status_importing_track(inputs)
	if (locale === "it") return it_work_order_import_status_importing_track(inputs)
	if (locale === "ru") return ru_work_order_import_status_importing_track(inputs)
	if (locale === "es") return es_work_order_import_status_importing_track(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_importing_track(inputs)
	if (locale === "ja") return ja_work_order_import_status_importing_track(inputs)
	if (locale === "hi") return hi_work_order_import_status_importing_track(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_importing_track(inputs)
	return en_work_order_import_status_importing_track(inputs)
});